export default function initHeaderObserver() {
  const header = document.querySelector(".project-header");
  if (!header) return;

  // Select the target element
  const target = document.querySelector(".project-header");

  // Create an IntersectionObserver instance
  const observer = new IntersectionObserver(
    function (entries, observer) {
      // Loop through the entries
      entries.forEach((entry) => {
        // Check if the target is intersecting
        if (entry.isIntersecting) {
          // If the target is entering the viewport, remove the class
          document.body.classList.remove("header-hidden");
        } else {
          // If the target is leaving the viewport, add the class
          document.body.classList.add("header-hidden");
        }
      });
    },
    {
      // Set the threshold for when the callback should be executed
      // 0.0 means every time the target enters or leaves the viewport
      threshold: 0.0,
    }
  );

  // Start observing the target element
  observer.observe(target);
}
